import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { UserService } from './services/user.service';

export const verifyEmailInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const messageService = inject(MessageService);
  const userService = inject(UserService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        const errorDetail =
          error.error?.['detail'] ||
          'You do not have permission to perform this action.';
        console.log('Permission denied error detail:', errorDetail);

        if (errorDetail === 'Email not verified') {
          router.navigate(['/verify-email']);
        } else if (!userService.user()) {
          // No user loaded — this is a session expiry, not a permission denial.
          // Let AuthGuard handle the redirect to login.
        } else if (req.method === 'GET') {
          router.navigate(['/forbidden']);
        } else {
          messageService.add({
            severity: 'error',
            summary: 'Permission Denied',
            detail: errorDetail,
          });
        }
      }
      return throwError(() => error);
    }),
  );
};
